(function () {
    'use strict';

    angular
        .module('procedureModule')
        .directive('prcResponsibility', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.errorMessage = '@';
        directiveScope.onSelect = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope',
						 '$controller',
						 'permissionService',
                function ($scope,
						  $controller,
						  permissionService) {

                    // Box Template
                	$scope.baseTemplatePath = '/app/shared/procedure/prcResponsibility.[Template].tpl.html';

                	$scope.canEdit = permissionService.hasPermission('ProceduresManagement', 'Procedure', 'Edit');

                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'ProceduresManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'Procedure';

                    $controller('BoxTmplController', { $scope: $scope });

                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                if (attrs.onSelect) scope.showOnSelectAction = true;
            }
        }
    }
})();
